var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1469_62268)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_62268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 10,
    fill: "#22C55E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5917 8.00822C18.5142 7.93011 18.4221 7.86811 18.3205 7.82581C18.219 7.7835 18.11 7.76172 18 7.76172C17.89 7.76172 17.7811 7.7835 17.6796 7.82581C17.578 7.86811 17.4858 7.93011 17.4084 8.00822L11.2 14.2249L8.59171 11.6082C8.51127 11.5305 8.41632 11.4694 8.31227 11.4284C8.20823 11.3874 8.09713 11.3673 7.98531 11.3692C7.87349 11.3712 7.76315 11.3951 7.66058 11.4397C7.55802 11.4843 7.46524 11.5486 7.38754 11.6291C7.30984 11.7095 7.24875 11.8044 7.20774 11.9085C7.16674 12.0125 7.14663 12.1236 7.14856 12.2354C7.1505 12.3473 7.17444 12.4576 7.21902 12.5602C7.2636 12.6627 7.32794 12.7555 7.40837 12.8332L10.6084 16.0332C10.6858 16.1113 10.778 16.1733 10.8796 16.2156C10.9811 16.2579 11.09 16.2797 11.2 16.2797C11.31 16.2797 11.419 16.2579 11.5205 16.2156C11.6221 16.1733 11.7142 16.1113 11.7917 16.0332L18.5917 9.23322C18.6763 9.15518 18.7438 9.06047 18.79 8.95506C18.8361 8.84964 18.86 8.7358 18.86 8.62072C18.86 8.50563 18.8361 8.3918 18.79 8.28638C18.7438 8.18096 18.6763 8.08625 18.5917 8.00822Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1469_62268",
    x: 0.5,
    y: 0.75,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1469_62268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1469_62268",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_62268"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.07871de99d55713e86a5ca91edf0a7d7.svg";
export { ForwardRef as ReactComponent };